import { BookingDetails } from "../types";

export const bookingDetails: BookingDetails = {
  partySize: 2,
  selectedDate: new Date(2025, 6, 5),
  timeSlot: {
    MicrositeName: "BossaNova",
    TimeSlot: {
      TimeSlot: "2024-07-01T12:00:00",
      HasStandardAvailability: true,
      IsLeaveTimeRequired: true,
      LeaveTime: "14:00:00",
      AvailablePromotions: [
        {
          Id: 6,
          FeeAmount: 0,
          LeaveTime: "",
          BasePrice: 0,
        },
        {
          Id: 7,
          FeeAmount: 0,
          LeaveTime: "",
          BasePrice: 0,
        },
        {
          Id: 8,
          FeeAmount: 0,
          LeaveTime: "12:30:00",
          BasePrice: 0,
        },
      ],
    },
  },
};
